import moment from 'moment';

export default date => date && moment(date, 'YYYY-MM-DD').format('l');
